import { DialogObject } from '@/components/dialog/dialog.types';
import { FormBuilderComponent } from '@/components/form-builder/form-builder.component';
import { DynamicField, DynamicForm, FieldVariant, MultiSelectFieldProps, SelectOption } from '@/components/form-builder/form-builder.types';
import { getSingleFieldObjectFactory } from '@/components/form-builder/utils/single-field-factory';
import { PpmRepository } from '@/store/ppm-state/ppm-state.repository';

interface getPPMCommiteeMemberDialogProps {
  store: PpmRepository;
  members: SelectOption[];
  validate: () => void;
}

export const getPPMCommiteeMemberDialog = ({ store, members, validate }: getPPMCommiteeMemberDialogProps): DialogObject => {
  const committeField: DynamicField<MultiSelectFieldProps> = {
    label: 'ppm.form.committee-member',
    variant: FieldVariant.SELECT,
    isRequired: true,
    props: {
      placeholder: 'ppm.form.placeholders.committee-member',
      options: members,
      value: store.getObservable('comMemberSelected'),
      onSelectChange: (value: any) => {
        store.set('comMemberSelected', value);
        store.setNested('dto', 'assigneeUserId', value.code);
      },
    },
  };
  const formObject: DynamicForm = getSingleFieldObjectFactory(committeField);
  return {
    title: 'ppm.form.committee-member',
    actions: [
      {
        label: 'ppm.actions.validate',
        variant: 'success',
        onClick: () => validate(),
      },
    ],
    component: {
      outlet: FormBuilderComponent,
      props: {
        formObject,
      },
    },
  };
};
